import { UserItemDto } from '@/api/generated';
import {
  userRolesOptionsTranslation,
  UserRolesOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { UsersListSearchFormModel } from '@/views/users/list/model/UsersListSearchForm.model.ts';

type FormType = Record<keyof UserItemDto, string>;

const Form: FormType = {
  email: 'Email',
  enabled: 'Aktywne',
  externalUserId: '',
  firstName: 'Imię',
  lastName: 'Nazwisko',
  phone: 'Telefon',
  role: 'Rola',
  userBusinessId: 'Identyfikator użytkownika',
  userId: '',
};

export type UsersListTranslation = {
  dialog: {
    edit: {
      accessHint: string;
      accessLink: string;
      button: {
        cancel: string;
        save: string;
      };
      form: FormType;
      title: string;
      userRolesOptions: UserRolesOptionsTranslation;
    };
  };
  table: {
    body: FormType;
    head: Record<keyof UsersListSearchFormModel, string>;
  };
};

export const usersListTranslation: UsersListTranslation = {
  dialog: {
    edit: {
      accessHint: 'Rolę i aktywność konta zmienia administrator w Administracji.',
      accessLink: 'Przejdź do Administracji',
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
      },
      form: Form,
      title: 'Aktualizacja konta',
      userRolesOptions: userRolesOptionsTranslation,
    },
  },
  table: {
    body: Form,
    head: {
      fullTextSearchInput: 'Wyszukaj użytkownika',
    },
  },
};
